import { Configuration } from "../interface/Configuration";

export const configurationsGT: Configuration = {
    productId: "GT",
    productName: "General Training",
    partRules: [
        {
            noResponse: {
                name: "No Response",
                seconds: 7,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 0,
            },
            repeatStop: {
                name: "Repeat Stop",
                maxRepeat: 1,
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 7,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 5,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeatStop: {
                name: "Repeat Stop",
                maxRepeat: 1,
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 7,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeatStop: {
                name: "Repeat Stop",
                maxRepeat: 1,
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: true,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: true,
            },
        },
    ],
};

const configurationsTrial: Configuration = {
    productId: "Trial",
    productName: "CMS Trial",
    partRules: [
        {
            noResponse: {
                name: "No Response",
                seconds: 5,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 0,
            },
            repeatStop: {
                name: "Repeat Stop",
                maxRepeat: 1,
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 5,
                playVariant: false,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeatStop: {
                name: "Repeat Stop",
                maxRepeat: 1,
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: false,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: false,
            },
        },
        {
            noResponse: {
                name: "No Response",
                seconds: 5,
                playVariant: true,
            },
            fullResponse: {
                name: "Full Response",
                seconds: 3,
            },
            shortResponse: {
                name: "Short Response",
                maxEncourage: 2,
            },
            repeatStop: {
                name: "Repeat Stop",
                maxRepeat: 1,
            },
            partTimeOffset: {
                name: "Part Time Offset",
                seconds: 20,
            },
            intentRepeat: {
                name: "Intent Repeat",
                enabled: true,
            },
            intentStuck: {
                name: "Intent Stuck",
                enabled: true,
            },
            intentMoveOn: {
                name: "Intent Move On",
                enabled: true,
            },
        },
    ],
};

export const partIndexConfig: Record<string, number> = {
    PART1: 0,
    PART2: 1,
    PART3: 2,
};

// Simulate network delay
export const fetchConfiguration = (product?: string) =>
    new Promise<Configuration>((resolve) => {
        setTimeout(() => {
            resolve(product === "GT" || product === "HOELT" ? configurationsGT : configurationsTrial);
        }, 1500);
    });
